import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import urls from "../constants/urls"
import userInfo from "../pages/Common/userInfo"

export const mainSplitApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: urls.BASE_URL,
        prepareHeaders: (headers, { endpoint }) => {
            const token = userInfo("access_token")
            if (token && endpoint !== "uploadFileToPresignedUrl") {
                headers.set("Auth-Token", `${token}`)
            }

            // if (token && endpoint !== "generate_presigned_url") {
            //     headers.set("Content-Type", "multipart/form-data")
            // }

            return headers
        },
    }),

    endpoints: () => ({}),

    tagTypes: [],
})
